import React, {Component} from 'react';
import {
  Table,
  TableBody,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import { calculateSingleProductTotal, formatNumber } from '../../utils/orderService';

class OrderDetails extends Component {
  state = {
    stripedRows: false,
    showRowHover: false,
    selectable: false,
    multiSelectable: false,
    enableSelectAll: false,
    deselectOnClickaway: true,
    showCheckboxes: false,
    height: `${56 + this.props.height}px`,

  }



  render() {
    return (
      <div>
        <Table
          style={{tableLayout: 'auto'}}
          bodyStyle= {{ overflowX: undefined, overflowY: undefined }}
          height={this.state.height}
          selectable={this.state.selectable}
          multiSelectable={this.state.multiSelectable}
        >
          <TableBody
            displayRowCheckbox={this.state.showCheckboxes}
            deselectOnClickaway={this.state.deselectOnClickaway}
            showRowHover={this.state.showRowHover}
            stripedRows={this.state.stripedRows}
          >
            <TableRow>
              {this.props.headers.map((header, index) => {
                return <TableHeaderColumn key={index} tooltip={header}>{header}</TableHeaderColumn>
              })}
            </TableRow>
            {this.props.tableData.map( (row, index) => (
              <TableRow key={index}>
                <TableRowColumn>{row.key}</TableRowColumn>
                <TableRowColumn>{row.product_name}</TableRowColumn>
                <TableRowColumn>{formatNumber(row.price_item * row.pcscase)}</TableRowColumn>
                <TableRowColumn>{row.zbritje}%</TableRowColumn>
                <TableRowColumn>{formatNumber(row.client_quantity, true)}</TableRowColumn>
                <TableRowColumn>{row.tvsh}</TableRowColumn>
                <TableRowColumn>{
                  formatNumber(calculateSingleProductTotal({
                    price: row.price_item,
                    quantity: row.client_quantity,
                    discount: row.zbritje,
                    pcscase: row.pcscase
                  }))}
                </TableRowColumn>
              </TableRow>
              ))}
          </TableBody>
        </Table>
      </div>
    );
  }
}



export default OrderDetails;



// WEBPACK FOOTER //
// ./src/components/Orders/OrderDetails.js